import { useEffect, useState } from 'react';
import API from '../api/axios';
import './Revenue.css';

const Revenue = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    API.get('/revenue')
      .then(res => setData(res.data))
      .catch(console.error);
  }, []);

  if (!data) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="revenue-page">
      <h1>💰 Revenue</h1>
      <div className="revenue-cards">
        <div className="rev-card highlight">
          <span className="rev-label">Toplam Gelir</span>
          <span className="rev-value">{data.total} USDT</span>
        </div>
      </div>
      <div className="revenue-grid">
        <div className="revenue-section">
          <h3>📅 Günlük</h3>
          {data.daily.map(d => (
            <div key={d.date} className="rev-row">
              <span>{new Date(d.date).toLocaleDateString('tr-TR')}</span>
              <span>{d.total} USDT</span>
            </div>
          ))}
        </div>
        <div className="revenue-section">
          <h3>📆 Haftalık</h3>
          {data.weekly.map(w => (
            <div key={w.week} className="rev-row">
              <span>Hafta {w.week}</span>
              <span>{w.total} USDT</span>
            </div>
          ))}
        </div>
        <div className="revenue-section">
          <h3>📊 Aylık</h3>
          {data.monthly.map(m => (
            <div key={m.month} className="rev-row">
              <span>{m.month}</span>
              <span>{m.total} USDT</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Revenue;